import { DecimalInputCell } from './DecimalInputCell';

export default DecimalInputCell;
